<div class="accordion accordion-element re-bg-white re-text-sm re-block re-mb-5 re-font-regular ">
  <button
    #accordionitem
    class="title re-w-full re-text-left question re-text-secondary re-py-15 re-pl-15 re-pr-60 re-leading-m re-relative re-cursor-pointer hover:re-text-secondary-hover"
    type="button"
    (click)="itemSelected(accordionitem);"
    [attr.aria-expanded]="opened"
    [attr.aria-controls]="contentId"
    [id]="buttonId"
  >
    {{ title }}
    <span [class.opened]="opened" class="re-absolute re-right-0 re-top-0 re-mr-15 re-mt-15">
      <svg-icon src="assets/icons/plusminus.svg"></svg-icon>
    </span>
  </button>
  <div
    #accordioncontent
    class="accordion-content accordion-element re-bg-white re-text-sm re-block re-mb-5 re-font-lighten re-px-15 re-pb-30 re-lean-m"
    [class.accordion-open]="opened"
    [class.accordion-closed]="!opened"
    [attr.aria-hidden]="!opened"
    role="region"
    [id]="contentId"
    [attr.aria-labelledby]="buttonId"
  >
    <ng-content></ng-content>
  </div>
</div>
